import { useState } from 'react';

import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import TextFieldComponent from '../FormField/TextFieldComponent';
import Actions from './ActionsComponent';

const PromptUserForValue = (props) => {
  const { t } = useTransl();
  const {
    defaultValue,
    bodyText,
    onConfirm,
    onConfirmText,
    onCancel,
    onCancelText,
  } = props;
  const [value, setValue] = useState(defaultValue);

  const actions = [
    {
      label: onCancelText || t('actions.cancel'),
      onClick: onCancel,
      color: 'secondary',
    },
    {
      label: onConfirmText || t('actions.submit'),
      onClick: () => onConfirm(value),
      color: 'primary',
    },
  ];
  return (
    <>
      <Typography variant="body1" component="div">
        {bodyText}
      </Typography>
      <TextFieldComponent
        input={{
          value: value || '',
          onChange: (event) => setValue(event.target.value),
        }}
        meta={{}}
      />
      <Actions actions={actions} />
    </>
  );
};

PromptUserForValue.defaultProps = {
  defaultValue: '',
};

PromptUserForValue.propTypes = {
  bodyText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancelText: PropTypes.string,
  onConfirmText: PropTypes.string,
  defaultValue: PropTypes.string,
};

export default PromptUserForValue;
